// lib
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

// src
import { loginAndKeepPath } from "actions/user/thunks";

const PREFIX = "auth/";
const getTarget = (pathname) => pathname.slice(PREFIX.length);

const LoggedGate = () => {
  const { t } = useTranslation();
  const { isLogged, isAuthAborted, isAuthPending, isAuthRejected } = useSelector(
    (state) => state.user,
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const target = getTarget(location.pathname);

  useEffect(() => {
    if (isLogged) {
      history.push(target);
      return;
    }
    if (isAuthAborted || isAuthPending || isAuthRejected) return;
    dispatch(loginAndKeepPath(target));
  }, [dispatch, history, isAuthAborted, isAuthPending, isAuthRejected, isLogged, target]);

  if (isAuthRejected)
    return (
      <p className="auth-rejected" role="alert">
        {t("errors.unknownAccount")}
      </p>
    );

  return null;
};

export default LoggedGate;
